import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAngebotListStatus: 'idle',
    loadAngebotListError: undefined as any,
    loadAngebotListLastArgs: undefined as any,
    loadAngebotStatus: 'idle',
    loadAngebotError: undefined as any,
    saveAngebotStatus: 'idle',
    saveAngebotError: undefined as any,
    deleteAngebotStatus: 'idle',
    deleteAngebotError: undefined as any,

    angebotList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAngebotList = createAsyncThunk('meldungAngebotSlice/loadAngebotList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().meldungAngebotSlice.loadAngebotListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisangebot/?action=gte&MIN_MELDUNGID=${parentModel.HDR_ID}&MAX_MELDUNGID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAngebotListStatus } = getState().meldungAngebotSlice
        return loadAngebotListStatus !== 'pending'
    }
})

export const loadAngebot = createAsyncThunk('meldungAngebotSlice/loadAngebot', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisangebot/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAngebotStatus } = getState().meldungAngebotSlice
        return loadAngebotStatus !== 'pending'
    }
})

export const saveAngebot = createAsyncThunk('meldungAngebotSlice/saveAngebot', async ({ angebot }: any, { rejectWithValue }: any) => {
    let promises = []
    if (angebot?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurisangebot/${ angebot?.HDR_ID }/`,
            prepareData(angebot),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurisangebot/`,
            prepareData(angebot),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveAngebotStatus } = getState().meldungAngebotSlice
        return saveAngebotStatus !== 'pending'
    }
})

export const deleteAngebot = createAsyncThunk('meldungAngebotSlice/deleteAngebot', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurisangebot/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteAngebotStatus } = getState().meldungAngebotSlice
        return deleteAngebotStatus !== 'pending'
    }
})

const AngebotSlice = createSlice({
    name: 'meldungAngebotSlice',
    initialState,
    reducers: {
        resetloadAngebotListError: (state) => {
            state.loadAngebotListError = undefined
        },
        resetloadAngebot: (state) => {
            state.formItem = undefined
            state.loadAngebotError = undefined
        },
        resetloadAngebotError: (state) => {
            state.loadAngebotError = undefined
        },
        resetsaveAngebot: (state) => {
            state.formItem = undefined
            state.saveAngebotError = undefined
        },
        resetsaveAngebotError: (state) => {
            state.saveAngebotError = undefined
        },
        resetdeleteAngebotError: (state) => {
            state.deleteAngebotError = undefined
        },
        removeFromAngebotListById: (state, action) => {
            state.angebotList = state.angebotList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAngebotListByIds: (state, action) => {
            state.angebotList = state.angebotList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.angebotList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAngebotListStatus = 'preloaded'
            state.loadAngebotListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.angebotList = []
            state.loadAngebotListStatus = 'idle'
            state.loadAngebotListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAngebotList.pending, (state) => {
            state.loadAngebotListStatus = 'pending'
            state.loadAngebotListError = undefined
        })
        builder.addCase(loadAngebotList.fulfilled, (state, action) => {
            state.loadAngebotListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAngebotListLastArgs = action.payload.args

            {
                state.angebotList = action.payload.data

            }
        })
        builder.addCase(loadAngebotList.rejected, (state, action) => {
            state.loadAngebotListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAngebotListError = action.error.message
            } else {
                state.loadAngebotListError = action.payload
            }
        })

        builder.addCase(loadAngebot.pending, (state) => {
            state.loadAngebotStatus = 'pending'
            state.loadAngebotError = undefined
        })
        builder.addCase(loadAngebot.fulfilled, (state, action) => {
            state.loadAngebotStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.angebotList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.angebotList.push(newItem) }
                else { state.angebotList[i] = { ...state.angebotList[i], ...newItem } }
            }
        })
        builder.addCase(loadAngebot.rejected, (state, action) => {
            state.loadAngebotStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAngebotError = action.error.message
            } else {
                state.loadAngebotError = action.payload
            }
        })

        builder.addCase(saveAngebot.pending, (state) => {
            state.saveAngebotStatus = 'pending'
            state.saveAngebotError = undefined
        })
        builder.addCase(saveAngebot.fulfilled, (state, action) => {
            state.saveAngebotStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.angebotList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.angebotList.push(newItem) }
                else { state.angebotList[i] = { ...state.angebotList[i], ...newItem } }
            }
        })
        builder.addCase(saveAngebot.rejected, (state, action) => {
            state.saveAngebotStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveAngebotError = action.error.message
            } else {
                state.saveAngebotError = action.payload
            }
        })

        builder.addCase(deleteAngebot.pending, (state) => {
            state.deleteAngebotStatus = 'pending'
            state.deleteAngebotError = undefined
        })
        builder.addCase(deleteAngebot.fulfilled, (state, action) => {
            state.deleteAngebotStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.angebotList = state.angebotList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.angebotList = state.angebotList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteAngebot.rejected, (state, action) => {
            state.deleteAngebotStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteAngebotError = action.error.message
            } else {
                state.deleteAngebotError = action.payload
            }
        })

    }
})

export const {
    resetloadAngebotListError,
    resetloadAngebot,
    resetloadAngebotError,
    resetsaveAngebot,
    resetsaveAngebotError,
    resetdeleteAngebotError,
    removeFromAngebotListById,
    removeFromAngebotListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AngebotSlice.actions
export default AngebotSlice.reducer
